<template>
  <div class="">
    <b-row>
      <div v-if="selectedBarrelId && addToBarrel" class="card-header col-5">
        <BarrelBreakdown
          :barrelId="selectedBarrelId"
          @fullnessRetrieved="populateFullness"
          @startBarrelLoading="hideBarrelBtn"
          @stopBarrelLoading="showBarrelBtn"
        />
        <router-link
          v-if="displayBarrelBtn"
          class="btn btn-primary"
          :to="{
            name: 'Manage',
            params: { barrelId: selectedBarrelId },
          }"
        >
          Details
        </router-link>
      </div>
      <div>
        <h4>
          <span>Add Items to &nbsp;</span>
          <input type="radio" :value="false" v-model="addToCustomer" />
          <label for="one">&nbsp;Barrel</label>
          &nbsp;
          <input type="radio" :value="true" v-model="addToCustomer" />
          <label for="two">&nbsp;Customer</label>
        </h4>
      </div>
      <div class="card-header col-7 pt-0">
        <span
          v-if="addToBarrel"
          class="card-label page-title fw-bolder fs-3 mb-1"
          >Barrel #<select
            class="form-select"
            v-if="!id"
            v-model="selectedBarrelId"
          >
            <option value="" selected>Select a Barrel</option>
            <option
              v-for="barrel in barrels"
              :key="barrel.LogicalBarrelId"
              :value="barrel.LogicalBarrelId"
            >
              {{ barrel.LogicalBarrelId }}
            </option>
          </select>
          <span v-if="id">{{ id }}</span>
        </span>
        <span v-else class="card-label page-title fw-bolder fs-3 mb-1"
          >Customer
          <select class="form-select" v-if="!pybNumber" v-model="customerPyb">
            <option value="" selected>Select a Customer</option>
            <option
              v-for="customer in customers"
              :key="customer.pybNumber"
              :value="customer.pybNumber"
            >
              {{ formatCustomer(customer) }}
            </option>
          </select>
          <span v-if="id">{{ id }}</span>
        </span>
        <FullnessDropdown
          class="mt-5"
          @updated="refresh"
          :barrelId="selectedBarrelId"
          :fullness="item.barrelFullness"
          v-if="selectedBarrelId && addToBarrel"
        />
      </div>
    </b-row>
    <!--begin::Tap pane-->
    <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
      <form @submit.prevent="addItemConfirmation">
        <div class="fv-row fv-plugins-icon-container">
          <!--begin::Label-->
          <label class="d-flex align-items-center fs-5 fw-bold mt-6">
            <span class="required">Tracking Number</span>
            <i
              class="fas fa-exclamation-circle ms-2 fs-7"
              data-bs-toggle="tooltip"
              v-b-tooltip.hover
              title="unique ID number or code assigned to a package which allows you to monitor its movement"
            ></i>
          </label>
          <!--end::Label-->
          <!--begin::Input-->
          <input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model="item.trackingNumber"
          />
          <!--end::Input-->
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
        <div class="row mb-5">
          <div class="fv-row fv-plugins-icon-container col-6">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-5 fw-bold mt-6">
              <span class="required">Courier</span>
              <i
                class="fas fa-exclamation-circle ms-2 fs-7"
                data-bs-toggle="tooltip"
                v-b-tooltip.hover
                title="company that transports packages"
              ></i>
            </label>
            <!--end::Label-->
            <!--begin::Input-->
            <select
              v-model="item.courier"
              class="
                custom-select
                form-control form-control-lg form-control-solid
              "
            >
              <option selected disabled>Select Courier</option>
              <option value="UPS">UPS</option>
              <option value="FedEx">FedEx</option>
              <option value="USPS">USPS</option>
              <option value="DHL">DHL</option>
              <option
                v-for="courier in courierList"
                :key="courier"
                :value="courier"
              >
                {{ courier }}
              </option>
            </select>
          </div>
          <div
            v-if="addToBarrel"
            class="fv-row fv-plugins-icon-container col-6"
          >
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-5 fw-bold mt-6">
              <span class="required">Fullness</span>
              <i
                class="fas fa-exclamation-circle ms-2 fs-7"
                data-bs-toggle="tooltip"
                v-b-tooltip.hover
                title="how filled barrel is"
              ></i>
            </label>
            <!--end::Label-->
            <!--begin::Input-->
            <select
              class="form-control form-control-lg form-control-solid"
              v-model="item.barrelFullness"
            >
              <option
                v-for="full in fullnessList"
                :key="full.value"
                :value="full.label"
              >
                {{ full.label }}
              </option>
            </select>
            <!--end::Input-->
            <div class="fv-plugins-message-container invalid-feedback"></div>
          </div>
        </div>
        <div :class="itemBoxClass" :style="itemBoxStyle">
          <div
            class="row ml-1"
            v-for="(details, index) in item.items"
            :key="index"
          >
            <div v-if="item.items.length > 1" class="col-6 align-self-center">
              <b-badge> #{{ index + 1 }} </b-badge>
            </div>
            <div class="col-6 align-self-center text-right">
              <v-icon
                v-if="item.items.length > 1"
                @click.prevent="removeItem(index)"
                size="28"
              >
                mdi-close-circle-outline
              </v-icon>
            </div>
            <div class="col-12 align-self-center">
              <AddItemDetails
                :class="addItemDetailsClass"
                :cat="details.description"
                :name="details.itemName"
                :quant="details.quantity"
                :permit="details.permitted"
                :reason="details.prohibitReason"
                v-bind:itemName.sync="details.itemName"
                v-bind:description.sync="details.description"
                v-bind:quantity.sync="details.quantity"
                v-bind:permitted.sync="details.permitted"
                v-bind:prohibitedReason.sync="details.prohibitReason"
              />
            </div>

            <hr
              v-if="item.items.length > 1 && index != item.items.length - 1"
              class="mb-0"
              style="background-color: black; height: 2px"
            />
          </div>
        </div>
        <b-row v-if="canAddItems" class="justify-content-md-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                :disabled="!canAddItems"
                @click.prevent="addDetails"
                icon
                :color="colorTheme.BLUE"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Additional Item</span>
          </v-tooltip>
        </b-row>

        <button
          type="submit"
          :disabled="preventSubmission"
          class="btn fw-bold w-100 mt-6 btn-primary"
        >
          Submit
          <span
            v-if="loading"
            class="spinner-border spinner-border-md align-middle ms-2"
          ></span>
          <svg
            v-if="!loading"
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.04956 11.6921H14.9056"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </form>
    </div>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="addItem"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
  <!--end::General Widget 1-->
  <!--end::Col-->
</template>

<script>
import { ApiService } from "@/services/ApiService";
import BarrelBreakdown from "@/components/BarrelBreakdown.vue";
import FullnessDropdown from "@/components/FullnessDropdown.vue";
import AddItemDetails from "@/components/AddItemDetails.vue";
import { error } from "@/services/LoggerService";
import fullnessData from "@/config/fullness.json";
import couriers from "@/config/couriers.json";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";
import { ColorTheme } from "@/mixins/ColorTheme";

export default mixins(ConfirmationModalMixin, SnackbarNotifierMixin).extend({
  name: "AddItem",
  props: {
    id: { type: String },
    fullness: { type: String },
    pybNumber: { type: String },
    isCustomer: { type: Boolean },
  },
  data() {
    return {
      colorTheme: ColorTheme,
      loading: false,
      barrels: [],
      customers: [],
      itemCount: 1,
      selectedBarrelId: "",
      customerPyb: "",
      addToCustomer: false,
      item: {
        items: [{ quantity: 1 }],
      },
      itemDetails: {},
      adding: false,
      descriptions: [],
      courierList: couriers,
      displayBarrelBtn: true,
    };
  },
  components: {
    BarrelBreakdown,
    FullnessDropdown,
    AddItemDetails,
    ConfirmationModal,
    SnackbarNotifier,
  },
  methods: {
    hideBarrelBtn() {
      this.displayBarrelBtn = false;
    },
    showBarrelBtn() {
      this.displayBarrelBtn = true;
    },
    addItemConfirmation() {
      const title = this.addToCustomer
        ? "Add Item To Customer"
        : "Add Item To Barrel";
      this.showConfirmationModal({
        title,
        message: `Are you sure you want to add <b><em>${
          this.item.items.length > 1
            ? "these items"
            : this.item.items[0].itemName
        }</em></b>?`,
      });
    },
    async addItem() {
      try {
        this.loading = true;
        this.startConfirmationLoading();
        this.item.isBarrelFullnessUpdated =
          this.fullness != this.item.barrelFullness;
        if (this.addToBarrel) this.item.logicalBarrelId = this.barrelId;
        else this.item.pybNumber = this.customerPyb;
        this.adding = true;
        let result = this.addToBarrel
          ? await ApiService.Instance.addItemToBarrel(this.item)
          : await ApiService.Instance.addCustomerItems(this.item);
        if (result) {
          this.showNotifier({
            message: `Successfully Add ${
              this.item.items.length > 1
                ? this.item.items.length + " Items"
                : this.item.items[0].itemName
            }`,
            snackbarType: "success",
          });
          this.item = {
            items: [{ quantity: 1 }],
          };
          this.$emit("added");
        }
        this.stopConfirmationLoading();
        this.loading = false;
      } catch (e) {
        this.stopConfirmationLoading();
        this.showNotifier({
          message: `Failed To Add ${
            this.item.items.length > 1 ? "Items" : this.item.items[0].itemName
          }`,
          snackbarType: "error",
        });
        this.loading = false;
        error(e);
      }
      this.adding = false;
    },
    removeItem(index) {
      this.$delete(this.item.items, index);
    },
    populateFullness(fullness) {
      this.item.barrelFullness = fullness;
    },
    addDetails() {
      this.item.items.push({ quantity: 1 });
    },
    refresh() {
      let temp = this.selectedBarrelId;
      (this.selectedBarrelId = ""), (this.selectedBarrelId = temp);
    },
    async getBarrels() {
      try {
        this.barrels = await ApiService.Instance.barrelByStatus({
          status: "ReadyForItems",
        });

        this.barrels = this.barrels.sort((a, b) => {
          return a.PYBNumber < b.PYBNumber;
        });
      } catch (e) {
        error(e);
      }
    },
    async getCustomers() {
      try {
        const result = await ApiService.Instance.getAllCustomers();
        if (result)
          this.customers = result.data.sort((a, b) => {
            return a.pybNumber < b.pybNumber;
          });
      } catch (e) {
        error(e);
      }
    },
    formatCustomer(customer) {
      return `${customer.firstName} ${customer.lastName} - ${customer.pybNumber}`;
    },
  },
  computed: {
    preventSubmission() {
      return (
        this.adding ||
        (!this.barrelId && this.addToBarrel) ||
        (!this.customerPyb && !this.addToBarrel) ||
        !this.item.courier ||
        !this.item.trackingNumber ||
        this.item.items.some((item) => {
          return !item.itemName || !item.description;
        }) ||
        this.loading
      );
    },
    addToBarrel() {
      return !(this.isCustomer || this.addToCustomer);
    },
    barrelId() {
      if (this.id) return this.id;
      return this.selectedBarrelId;
    },
    addItemBtnClass() {
      const defaultClass = "btn fw-bold w-100 mt-6";
      if (
        (!this.barrelId && this.addToCustomer) ||
        (!this.customerPyb && !this.addToBarrel) ||
        !this.item.courier ||
        !this.item.trackingNumber ||
        this.item.items.some((item) => {
          return !item.itemName || !item.description;
        }) ||
        this.loading
      )
        return `${defaultClass} btn-secondary disabled`;

      return `${defaultClass} btn-primary`;
    },
    itemBoxStyle() {
      if (this.item.items.length > 1)
        return `min-height=100px; max-height:350px; overflow-y:scroll;overflow-x:hidden;background-color:${this.colorTheme.LIGHT_GREY}`;
      return null;
    },
    itemBoxClass() {
      const defaultClass = "row mb-2 pt-2";
      if (this.item.items.length > 1) return defaultClass + " elevation-3";
      return defaultClass;
    },
    addItemDetailsClass() {
      if (this.item.items.length > 1) return "col-10";
      return null;
    },
    canAddItems() {
      return this.item.items.every((item) => {
        return item.itemName && item.description;
      });
    },
    fullnessList() {
      if (this.fullness)
        return fullnessData.filter((data) => {
          return (
            parseInt(data.label.replace("%", "")) >=
            parseInt(this.fullness.replace("%", ""))
          );
        });
      return fullnessData;
    },
  },
  async beforeMount() {
    try {
      await this.getBarrels();
      await this.getCustomers();
      if (this.fullness) this.item.barrelFullness = this.fullness;
    } catch (e) {
      error(e);
    }
  },
});
</script>

<style></style>
